module.exports = __webpack_public_path__ + "img/suppliment-factory.b96214a3.png";